import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icon_sucess.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0a268db0")

_pushScopeId("data-v-0a268db0")
const _hoisted_1 = { class: "dt-open-api-content dt-open-api-personal-add-app-container" }
const _hoisted_2 = { class: "dt-open-api-personal-add-app-box" }
const _hoisted_3 = {
  key: 0,
  class: "dt-open-api-personal-add-app-setup-sec"
}
const _hoisted_4 = {
  key: 0,
  class: "dt-open-api-personal-add-app-setup-sec-split"
}
const _hoisted_5 = {
  key: 1,
  class: "dt-open-api-personal-add-app-setup-content"
}
const _hoisted_6 = { class: "dt-appmange-form-row dt-appmange-form-row-icon" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "dt-appmange-form-row-icon-item-img" }, [
  /*#__PURE__*/_createVNode("div", { class: "dt-appmange-form-row-icon-add" })
], -1)
const _hoisted_8 = {
  key: 0,
  class: "dt-appmange-form-row-icon-item"
}
const _hoisted_9 = { class: "dt-appmange-form-row-icon-item-img" }
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "dt-open-api-upload-info clearfix" }, "支持jpg/png格式，要求长宽相等，大小5MB以内，推荐尺寸84*84px", -1)
const _hoisted_11 = { class: "dt-appmange-form-row dt-appmange-form-row-icon" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "dt-appmange-form-row-icon-item-img" }, [
  /*#__PURE__*/_createVNode("div", { class: "dt-appmange-form-row-icon-add" })
], -1)
const _hoisted_13 = { class: "dt-appmange-form-row-icon-item-img" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "dt-open-api-upload-info clearfix" }, "支持jpg/png格式，大小5MB以内，推荐尺寸214*341px,最多支持五张图片", -1)
const _hoisted_15 = { class: "dt-open-api-upload-info clearfix" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确 定")
const _hoisted_18 = {
  key: 2,
  class: "dt-open-api-personal-add-app-setup-content succes-content"
}
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "dt-open-api-personal-add-app-success-icon" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("p", { class: "dt-open-api-personal-add-app-success-text" }, "应用创建成功", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("返回应用列表")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 查看应用详情")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_link = _resolveComponent("el-link")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (!_ctx.formItem.id)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.stepList, (item, index) => {
              return (_openBlock(), _createBlock(_Fragment, {
                key: item.sort
              }, [
                _createVNode("span", {
                  class: ["dt-open-api-personal-add-app-setup-sec-sort-num", item.sort === _ctx.stepNum ? 'dt-open-api-personal-add-app-setup-sec-sort-num-active':'']
                }, _toDisplayString(item.sort), 3),
                _createVNode("span", {
                  class: item.sort === _ctx.stepNum ? 'dt-open-api-personal-add-app-setup-sec-txt':''
                }, _toDisplayString(item.title), 3),
                (index!=_ctx.stepList.length-1)
                  ? (_openBlock(), _createBlock("span", _hoisted_4))
                  : _createCommentVNode("", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]))
        : _createCommentVNode("", true),
      (_ctx.stepNum === 1)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_el_form, {
              ref: "formItemRef",
              model: _ctx.formItem,
              rules: _ctx.rules,
              "label-width": "130px"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_form_item, {
                  label: "应用名称",
                  prop: "title"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formItem.title,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.formItem.title = $event)),
                      modelModifiers: { trim: true },
                      maxlength: "50",
                      placeholder: "请输入应用名称"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "应用图标",
                  prop: "logo"
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_6, [
                      _createVNode("input", {
                        type: "file",
                        id: "uploadLogo",
                        ref: "fileInput",
                        onChange: _cache[2] || (_cache[2] = (...args) => (_ctx.logoToUpload(...args))),
                        class: "dt-open-api-upload-input",
                        accept: "image/*"
                      }, null, 544),
                      _createVNode("div", {
                        class: "dt-appmange-form-row-icon-item click-element",
                        onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.uploadLogoClick(...args)))
                      }, [
                        _hoisted_7
                      ]),
                      (_ctx.formItem.logo)
                        ? (_openBlock(), _createBlock("div", _hoisted_8, [
                            _createVNode("div", _hoisted_9, [
                              _createVNode("img", {
                                src: _ctx.formItem.logo
                              }, null, 8, ["src"]),
                              _createVNode("div", {
                                class: "dt-appmange-form-row-icon-item-img-remove-icon click-element",
                                onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.clearnLogo(...args)))
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_10
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "应用简介",
                  prop: "introduce"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formItem.introduce,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.formItem.introduce = $event)),
                      modelModifiers: { trim: true },
                      type: "textarea",
                      maxlength: "300",
                      placeholder: "请输入应用简介"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "应用分类",
                  prop: "categoryCode"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.curDictCode,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.curDictCode = $event)),
                      placeholder: "请选择应用分类",
                      "no-data-text": "暂无数据",
                      onChange: _cache[7] || (_cache[7] = $event => (_ctx.onCategoryChange($event)))
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dicts, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.dict_code,
                            label: item.dict_name,
                            value: item.dict_code
                          }, null, 8, ["label", "value"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "适用系统",
                  prop: "systemType"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: _ctx.selSystemTypeList,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.selSystemTypeList = $event)),
                      onChange: _ctx.systemTypeChange
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_checkbox, { label: "Windows" }),
                        _createVNode(_component_el_checkbox, { label: "Android" }),
                        _createVNode(_component_el_checkbox, { label: "ios" }),
                        _createVNode(_component_el_checkbox, { label: "Mac OS" })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "适用终端",
                  prop: "terminalType"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: _ctx.selTerminalTypeList,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => (_ctx.selTerminalTypeList = $event)),
                      onChange: _ctx.terminalTypeChange
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.terminalTypeList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            label: item.label,
                            key: item.value
                          }, null, 8, ["label"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "使用群体",
                  prop: "terminalType"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox_group, {
                      modelValue: _ctx.selUseGroupList,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => (_ctx.selUseGroupList = $event)),
                      onChange: _ctx.useGroupChange
                    }, {
                      default: _withId(() => [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.useGroupList, (item) => {
                          return (_openBlock(), _createBlock(_component_el_checkbox, {
                            label: item.label,
                            key: item.value
                          }, null, 8, ["label"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "使用场景",
                  prop: "introduce"
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formItem.useScene,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => (_ctx.formItem.useScene = $event)),
                      modelModifiers: { trim: true },
                      type: "textarea",
                      maxlength: "300",
                      placeholder: "请输入使用场景"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "应用截图" }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_11, [
                      _createVNode("input", {
                        type: "file",
                        id: "uploadScreenshot",
                        ref: "screenshotInput",
                        onChange: _cache[12] || (_cache[12] = (...args) => (_ctx.screenshotToUpload(...args))),
                        class: "dt-open-api-upload-input",
                        accept: "image/*"
                      }, null, 544),
                      _createVNode("div", {
                        class: "dt-appmange-form-row-icon-item click-element",
                        onClick: _cache[13] || (_cache[13] = (...args) => (_ctx.uploadScreenshotClick(...args)))
                      }, [
                        _hoisted_12
                      ]),
                      (_ctx.screenshotArr.length > 0)
                        ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.screenshotArr, (item, index) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "dt-appmange-form-row-icon-item",
                              key: index
                            }, [
                              _createVNode("div", _hoisted_13, [
                                _createVNode("img", { src: item }, null, 8, ["src"]),
                                _createVNode("div", {
                                  class: "dt-appmange-form-row-icon-item-img-remove-icon click-element",
                                  onClick: $event => (_ctx.clearnScreenshot(index))
                                }, null, 8, ["onClick"])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: _ctx.appPathTitle }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formItem.redirectUrl,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (_ctx.formItem.redirectUrl = $event)),
                      placeholder: `请输入${_ctx.appPathTitle}`
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createVNode("p", _hoisted_15, _toDisplayString(_ctx.appPathTitle) + "用于单点登录统一认证中心", 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_form_item, null, {
                  default: _withId(() => [
                    _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
                      default: _withId(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.addApp
                    }, {
                      default: _withId(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.stepNum === 2)
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _hoisted_19,
            _hoisted_20,
            _createVNode("div", null, [
              _createVNode(_component_el_link, {
                type: "primary",
                style: {"margin-right":"20px"},
                underline: _ctx.showUnderline,
                href: "javascript:void(0);",
                onClick: _cache[15] || (_cache[15] = $event => (_ctx.gotoPage('myapp')))
              }, {
                default: _withId(() => [
                  _hoisted_21
                ]),
                _: 1
              }, 8, ["underline"]),
              _createVNode(_component_el_link, {
                type: "primary",
                underline: _ctx.showUnderline,
                href: "javascript:void(0);",
                onClick: _cache[16] || (_cache[16] = $event => (_ctx.gotoPage('appinfo')))
              }, {
                default: _withId(() => [
                  _hoisted_22
                ]),
                _: 1
              }, 8, ["underline"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})